<script setup lang="ts">
import { computed } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import MainLayout from './layout/MainLayout.vue';

const route = useRoute();
const isLogin = computed(() => route.name === 'login');
</script>

<template>
  <RouterView v-if="isLogin" />
  <MainLayout v-else />
</template>
